import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { NeoDialog } from '@neogov/pattern-library/neo-dialog';
import { AccessDeniedModalComponent, AccessDeniedModalResult } from '../../presentation/modals/access-denied-modal';
import { resolveHomePath } from './resolve-home-path.util';

@Injectable({
  providedIn: 'root',
})
export class AccessDeniedDialogService {
  private readonly _router = inject(Router);
  private readonly _dialog = inject(NeoDialog);

  private readonly _isDialogOpen = signal(false);
  public readonly isDialogOpen = this._isDialogOpen.asReadonly();

  private readonly _wasShown = signal(false);
  public readonly wasShown = this._wasShown.asReadonly();

  private _homePath = '/cases/dashboard';

  public show(): void {
    if (this._isDialogOpen() || this._wasShown()) {
      return;
    }

    this._homePath = resolveHomePath(this._router.url);
    this._isDialogOpen.set(true);
    this._wasShown.set(true);

    const dialogRef = this._dialog.open<AccessDeniedModalComponent, undefined, AccessDeniedModalResult>(
      AccessDeniedModalComponent,
      {
        disableClose: true,
        closeOnNavigation: false,
        hasBackdrop: true,
        width: '600px',
        maxWidth: '600px',
      },
    );

    firstValueFrom(dialogRef.afterClosed())
      .then(() => {
        this._isDialogOpen.set(false);
        this._router.navigate([this._homePath]);
      })
      .catch(() => {
        this._isDialogOpen.set(false);
      });
  }
}
